
import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetMemberVaccineModuleList = (params: any) =>
    GET_ENC(`${BASE_URL}/api/MemberVaccineModule/GetList?` + params, null);

export const GetMemberVaccineModuleDetail = (params: any) =>
  GET_ENC(`${BASE_URL}/api/MemberVaccineModule/GetDetail?` + params, null);

export const CreateMemberVaccineModule = (data: any) =>
    POST_ENC(`${BASE_URL}/api/MemberVaccineModule/Create`, data);

export const UpdateMemberVaccineModule = (data: any) =>
    POST_ENC(`${BASE_URL}/api/MemberVaccineModule/Update`, data);

export const DeleteMemberVaccineModule = (data: any) =>
    POST_ENC(`${BASE_URL}/api/MemberVaccineModule/Delete`, data);

export const HandleUpdateAllMemberVaccineModule = (data: any) =>
    POST_ENC(`${BASE_URL}/api/MemberVaccineModule/UpdateAllMemberVaccineModule`, data);

export const HandleActivateMemberVaccinationModule = (data: any) =>
    POST_ENC(`${BASE_URL}/api/MemberVaccineModule/UpdateActivateMemberVaccinationModule`, data);